import PropTypes from 'prop-types';
import React from 'react';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import { PaymentUnauthorizedError } from '../../../../errors/Payment';
import { ACTError } from '../../../../errors/Smartcard';

import PaymentError from '../../../checkout/PaymentError';

function Error({ error, handleRetry }) {
    return (
        <Row>
            <Col md={ 6 } mdOffset={ 3 }>
                <div className="margin-top margin-bottom">
                    <PaymentError
                        error={ error }
                        onRetry={ handleRetry }
                        />
                </div>
            </Col>
        </Row>
    );
}

Error.propTypes = {
    error: PropTypes.oneOfType([
        PropTypes.instanceOf(PaymentUnauthorizedError),
        PropTypes.instanceOf(ACTError)
    ]),
    handleRetry: PropTypes.func.isRequired
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/account/smartcard/keyGoRegistration/Error.js